export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f6bf51113215f72bd53a42785991f37dc2435bb9b&name=fetchTypeahead!'